export default "__VITE_ASSET__vAiV1ykk__"